import { FaGift } from "react-icons/fa";

const PopupForm = ({ onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-[9999] p-4">
      {/* Main Popup Container */}
      <div className="bg-white p-5 rounded-xl shadow-lg relative w-full max-w-[500px] h-auto max-h-[90vh] flex flex-col overflow-hidden border border-gray-200">
        {/* Close Button */}
        <button
          className="absolute top-3 right-3 text-xl font-bold text-gray-700 hover:text-red-500 transition-colors"
          onClick={onClose}
        >
          &times;
        </button>

        {/* Heading Section */}
        <div className="flex flex-col items-center justify-center text-center mb-3">
          <h2 className="text-xl md:text-4xl font-bold text-teal-500">
            Free Download [PDF Ebook]
          </h2>
          <p className="text-gray-700 text-base md:text-4xl font-semibold mt-1">
            Latest Hairstyle Trends & Newspapers!
          </p>
          <p className="text-gray-600 text-base md:text-2xl mt-1">
            Join the community for no more boring salon visits.
          </p>
        </div>

        {/* Load Form inside an iframe */}
        <iframe
          src="/form.html"
          className="w-full h-[200px] md:h-[250px] flex-grow border-none rounded-lg mb-3"
          title="Embedded Form"
        ></iframe>
      </div>
    </div>
  );
};

export default PopupForm;
